<template>
  <div class="order-page">
    <BackNav :title="$t('order.listTitle')" />
    <div class="order-body">
      <OrderItem v-for="item of orderList" :key="item.id" :item="item" />
      <div v-if="orderList.length < total" class="load-more" @click="getMore">
        {{ $t('common.loadMore') }}
      </div>
      <div v-if="orderList.length === 0" class="empty">
        <van-icon name="records" class="empty-icon" />
        <div>{{ $t('common.noData') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { OrderService } from '@/services';
import OrderItem from './components/OrderItem';
import BackNav from '@/components/BackNav';

const orderList = ref([]);
const total = ref(0);
const pageNumber = ref(1);
const isQuery = ref(false);
const initOrder = async () => {
  const { result } = await OrderService.getOrderListApi({ pageNumber: pageNumber.value });
  if (isQuery.value) {
    orderList.value = result.data;
  } else {
    if (result.data.length) {
      orderList.value = [...orderList.value, ...result.data];
    } else if (pageNumber.value === 1) {
      orderList.value = [];
    }
  }
  total.value = result.total;
};
const getMore = () => {
  pageNumber.value += 1;
  initOrder();
};
onMounted(() => {
  initOrder();
});
</script>

<style lang="scss" scoped>
.order-page {
  min-height: 100vh;
  background: var(--bg-page);
  padding-bottom: 120px;
}
.order-body {
  padding: 20px 16px;
}
.load-more {
  text-align: center;
  color: var(--brand-primary);
  font-size: 26px;
  padding: 24px;
  cursor: pointer;
}
.empty {
  text-align: center;
  color: var(--text-muted);
  padding: 120px 0;
  .empty-icon {
    font-size: 100px;
    margin-bottom: 16px;
    opacity: 0.5;
  }
  font-size: 26px;
}
</style>
